import i18n from 'i18next'

/** Day duration in milliseconds. */
export const DAY_MS = 1_000 * 60 * 60 * 24

/** Maximum interval range day between two dates. */
export const MAX_DAY_RANGE = 62

/** Get a new date formatted. */
export const newDateFormatted = (days = 0, date?: Date | string): string => {
    const dateToUse = date ? new Date(date) : new Date()

    const [newDate] = new Date(dateToUse.setDate(dateToUse.getDate() + days))
        .toISOString()
        .split('T')

    return newDate
}

/** The default date to start the filter. */
export const DEFAULT_DATE_START = newDateFormatted(-7)

/** The default date to end the filter. */
export const DEFAULT_DATE_END = newDateFormatted()

/** Transform date in readable locale date. */
export const localeDate = (
    date: Date | string,
    dateStyle: Intl.DateTimeFormatOptions['dateStyle'] = 'short',
): string => {
    return new Date(date).toLocaleDateString(i18n.language, { dateStyle })
}

/** Transform date in readable locale time. */
export const localeTime = (
    date: Date,
    timeStyle: Intl.DateTimeFormatOptions['timeStyle'] = 'short',
): string => {
    return new Date(date).toLocaleTimeString(i18n.language, { timeStyle })
}

/** Transform date in readable locale date and time. */
export const localeDateAndTime = (date: string): string => {
    return new Date(date).toLocaleString(i18n.language, {
        timeZoneName: 'short',
    })
}

/** Transform date in readable locale month in long format with the year. */
export const localeMonthAndYear = (date: string): string => {
    const formattedDate = new Date(date).toLocaleDateString(i18n.language, {
        year: 'numeric',
        month: 'long',
    })

    return formattedDate
}

export const transformHour = (value: string) => {
    if (value) {
        const date = new Date()

        date.setHours(Number(value.split(':')[0]))
        date.setMinutes(Number(value.split(':')[1]))

        return date
    }
    return value
}

/** Get the timezone of the user to return to the backend. */
export const getTimeZoneNumber = (): string => {
    const timeZoneCalculated = new Date().getTimezoneOffset() / 60
    const splitted = Math.abs(timeZoneCalculated).toString().split('.')

    const operator =
        timeZoneCalculated.toString().startsWith('-') ||
        timeZoneCalculated === 0
            ? '+'
            : '-'

    const hours = splitted[0].length === 2 ? splitted[0] : `0${splitted[0]}`
    const minutes = timeZoneCalculated.toString().endsWith('.5') ? '30' : '00'

    return `${operator}${hours}:${minutes}`
}

export const getTimeOld = (date: Date | string): string => {
    const dateParsed = new Date(date)

    return `${dateParsed.getHours()}:${dateParsed.getMinutes()}`
}

export const getTime = (date: Date | string): string => {
    const dateParsed = new Date(date)

    return dateParsed.toLocaleTimeString('en-GB')
}

/** Get the number of day difference between two dates. */
export const getDayDifference = (
    dateStart: string,
    dateEnd: string,
): number => {
    return Math.abs(
        Math.floor(
            (Number(new Date(dateStart)) - Number(new Date(dateEnd))) / DAY_MS,
        ),
    )
}
